import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import VueSelect from 'vue-select'
import VueContentPlaceholders from 'vue-content-placeholders'
import './theme/overwrites.scss'

Vue.use(BootstrapVue)
Vue.use(VueContentPlaceholders)

Vue.component('v-select', VueSelect)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
